import { FC, memo, ReactNode } from 'react';
import Dialog from '../design-system/dialog.tsx';
import useMarketInfo from '../hooks/useMarketInfo.tsx';
import useNavigateTo from '../hooks/useNavigateTo.tsx';
import useShouldHidePnpClose from '../hooks/useShouldHidePnpClose.tsx';
import { useRegistrationStore } from '../store/store.ts';
import { IS_DEVELOPMENT } from '../utils/envConstants.ts';
import { storeTimerInfo } from '../utils/timer.ts';
import { resetProgressInLocalStorage } from '../utils/utils.ts';

const FlowDialog: FC<{ children: ReactNode }> = memo(({ children }) => {
  const { metadata, setMetadata } = useRegistrationStore();
  const { navigateToMarket } = useNavigateTo();
  const { market } = useMarketInfo();
  const hideClose = useShouldHidePnpClose();

  const handleClose = () => {
    resetProgressInLocalStorage(market);
    sessionStorage.setItem('fabric:registration:open', 'false');
    navigateToMarket(market);
    storeTimerInfo();
  };

  return (
    <Dialog
      isOpen={IS_DEVELOPMENT ? true : metadata?.isOpen}
      setIsOpen={(value) => {
        setMetadata({ isOpen: value })
        if (!value) {
          handleClose();
        }
      }}
      overlayClass="!md:items-end bg-black bg-opacity-50 backdrop-blur-sm"
      onClose={handleClose}
      hideClose={hideClose}
    >
      {children}
    </Dialog>
  )
},
);
FlowDialog.displayName = 'FlowDialog';

export default FlowDialog;
